import { Action } from "../../index";
import { combineReducers } from "redux";
import { Dispatch } from "react-redux";
import API from "../../../vendor/api";

import { clone } from "lodash";
import { normalize, Schema, arrayOf } from "normalizr";

import {  } from "../../../types/index";

/**
 * Actions
 */

export const ADD_USER_ENTITY = "meumedico/users/ADD_USER_ENTITY";
export function addUserEntity(user: API.User) {
    return {
        type: ADD_USER_ENTITY,
        payload: {
            user
        }
    };
}

export const ADD_USER_ENTITIES = "meumedico/users/ADD_USER_ENTITIES";
export function addUserEntities(users: UsersById) {
    return {
        type: ADD_USER_ENTITIES,
        payload: {
            users
        }
    };
}

// Reducer
interface UsersById {
    [chatId: string]: API.User;
}

export interface UserState {
    allIds: string[];
    byId: UsersById;
}

const INITIAL_STATE: UserState = {
    allIds: [],
    byId: {}
};

export interface UserEntityPayload {
    user: API.User;
}

export interface UserEntitiesPayload {
    users: UsersById;
}

function UsersById(state: UsersById = {}, action: Action<UserEntityPayload & UserEntitiesPayload>) {
    switch (action.type) {
        case ADD_USER_ENTITY:
            return (() => {
                let users = Object.assign({}, state);
                users[action.payload.user.id] = action.payload.user;
                return users;
            })();
         case ADD_USER_ENTITIES:
            return (() => {
                const payloadUsers = action.payload.users;
                let users = clone(state);
                Object.keys(payloadUsers).map(userId => {
                    users[userId] = payloadUsers[userId];
                });
                return users;
            })();
        default:
            return state;
    }
}

function allUsers(state: any = [], action: Action<any>) {
    switch (action.type) {
        case ADD_USER_ENTITY:
            return state.concat([action.payload.message.id]);
        case ADD_USER_ENTITIES:
            return (() => {
                const payloadUsers = action.payload.users;
                return state.concat(Object.keys(payloadUsers));
            })();
        default:
            return state;
    }
}

const usersReducer = combineReducers({
    byId : UsersById,
    allIds : allUsers
});

export default usersReducer;



// WEBPACK FOOTER //
// ./src/redux/modules/users/users.ts